import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import { Toaster } from "./components/ui/sonner";
import "./i18n";
import "./App.css";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import CookieConsent from "./components/CookieConsent";
import ConsentBanner from "./components/ConsentBanner";
import PrivateRoute from "./components/PrivateRoute";
import EmailVerifiedRoute from "./components/EmailVerifiedRoute";
import HomePage from "./pages/HomePage";
import HorseListingPage from "./pages/HorseListingPage";
import HorseDetailPage from "./pages/HorseDetailPage";
import ProductListingPage from "./pages/ProductListingPage";
import ProductDetailPage from "./pages/ProductDetailPage";
import TransportListingPage from "./pages/TransportListingPage";
import TransportDetailPage from "./pages/TransportDetailPage";
import CreateTransportAdPage from "./pages/CreateTransportAdPage";
import RidingSchoolListingPage from "./pages/RidingSchoolListingPage";
import RidingSchoolDetailPage from "./pages/RidingSchoolDetailPage";
import CreateRidingSchoolAdPage from "./pages/CreateRidingSchoolAdPage";
import StableListingPage from "./pages/StableListingPage";
import StableDetailPage from "./pages/StableDetailPage";
import CreateStableAdPage from "./pages/CreateStableAdPage";
import TrainerListingPage from "./pages/TrainerListingPage";
import TrainerDetailPage from "./pages/TrainerDetailPage";
import CreateTrainerAdPage from "./pages/CreateTrainerAdPage";
import EventListingPage from "./pages/EventListingPage";
import EventDetailPage from "./pages/EventDetailPage";
import CreateEventAdPage from "./pages/CreateEventAdPage";
import VetListingPage from "./pages/VetListingPage";
import VetDetailPage from "./pages/VetDetailPage";
import CreateVetAdPage from "./pages/CreateVetAdPage";
import AuthPage from "./pages/AuthPage";
import DashboardPage from "./pages/DashboardPage";
import CreateHorseAdPage from "./pages/CreateHorseAdPage";
import CreateProductAdPage from "./pages/CreateProductAdPage";
import MessagesPage from "./pages/MessagesPage";
import AdminPage from "./pages/AdminPage";
import PaymentSuccessPage from "./pages/PaymentSuccessPage";
import PaymentCheckoutPage from "./pages/PaymentCheckoutPage";
import LegalPage from "./pages/LegalPage";
import ForgotPasswordPage from "./pages/ForgotPasswordPage";
import ResetPasswordPage from "./pages/ResetPasswordPage";
import SellerVerificationPage from "./pages/SellerVerificationPage";
import SearchResultsPage from "./pages/SearchResultsPage";
import MapSearchPage from "./pages/MapSearchPage";
import SellerProfilePage from "./pages/SellerProfilePage";
import SellersDirectoryPage from "./pages/SellersDirectoryPage";
import VerifyEmailPage from "./pages/VerifyEmailPage";
import FAQPage from "./pages/FAQPage";
import SuggestionsPage from "./pages/SuggestionsPage";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <div className="min-h-screen flex flex-col bg-[#F9F7F2]">
          <Navbar />
          <main className="flex-1">
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/horses" element={<HorseListingPage />} />
              <Route path="/horses/:id" element={<HorseDetailPage />} />
              <Route path="/products" element={<ProductListingPage />} />
              <Route path="/products/:id" element={<ProductDetailPage />} />
							<Route path="/transports" element={<TransportListingPage />} />
							<Route path="/transports/:id" element={<TransportDetailPage />} />
							<Route path="/schools" element={<RidingSchoolListingPage />} />
							<Route path="/schools/:id" element={<RidingSchoolDetailPage />} />
							<Route path="/stables" element={<StableListingPage />} />
							<Route path="/stables/:id" element={<StableDetailPage />} />
							<Route path="/trainers" element={<TrainerListingPage />} />
							<Route path="/trainers/:id" element={<TrainerDetailPage />} />
							<Route path="/events" element={<EventListingPage />} />
							<Route path="/events/:id" element={<EventDetailPage />} />
							<Route path="/vets" element={<VetListingPage />} />
							<Route path="/vets/:id" element={<VetDetailPage />} />
							<Route path="/sellers" element={<SellersDirectoryPage />} />
							<Route path="/u/:slug" element={<SellerProfilePage />} />
							<Route path="/verify-email" element={<VerifyEmailPage />} />
							<Route path="/faq" element={<FAQPage />} />
							<Route path="/suggestions" element={<SuggestionsPage />} />
              <Route path="/auth" element={<AuthPage />} />
							<Route path="/dashboard" element={<PrivateRoute><DashboardPage /></PrivateRoute>} />
							<Route path="/sell/horse" element={<EmailVerifiedRoute><CreateHorseAdPage /></EmailVerifiedRoute>} />
							<Route path="/sell/product" element={<EmailVerifiedRoute><CreateProductAdPage /></EmailVerifiedRoute>} />
							<Route path="/sell/transport" element={<EmailVerifiedRoute><CreateTransportAdPage /></EmailVerifiedRoute>} />
							<Route path="/sell/school" element={<EmailVerifiedRoute><CreateRidingSchoolAdPage /></EmailVerifiedRoute>} />
							<Route path="/sell/stable" element={<EmailVerifiedRoute><CreateStableAdPage /></EmailVerifiedRoute>} />
							<Route path="/sell/trainer" element={<EmailVerifiedRoute><CreateTrainerAdPage /></EmailVerifiedRoute>} />
							<Route path="/sell/event" element={<EmailVerifiedRoute><CreateEventAdPage /></EmailVerifiedRoute>} />
							<Route path="/sell/vet" element={<EmailVerifiedRoute><CreateVetAdPage /></EmailVerifiedRoute>} />
							<Route path="/edit/horse/:id" element={<PrivateRoute><CreateHorseAdPage /></PrivateRoute>} />
							<Route path="/edit/product/:id" element={<PrivateRoute><CreateProductAdPage /></PrivateRoute>} />
							<Route path="/edit/transport/:id" element={<PrivateRoute><CreateTransportAdPage /></PrivateRoute>} />
							<Route path="/edit/school/:id" element={<PrivateRoute><CreateRidingSchoolAdPage /></PrivateRoute>} />
							<Route path="/edit/stable/:id" element={<PrivateRoute><CreateStableAdPage /></PrivateRoute>} />
							<Route path="/edit/trainer/:id" element={<PrivateRoute><CreateTrainerAdPage /></PrivateRoute>} />
							<Route path="/edit/event/:id" element={<PrivateRoute><CreateEventAdPage /></PrivateRoute>} />
							<Route path="/edit/vet/:id" element={<PrivateRoute><CreateVetAdPage /></PrivateRoute>} />
							<Route path="/clone/horse/:id" element={<PrivateRoute><CreateHorseAdPage /></PrivateRoute>} />
							<Route path="/clone/product/:id" element={<PrivateRoute><CreateProductAdPage /></PrivateRoute>} />
							<Route path="/clone/transport/:id" element={<PrivateRoute><CreateTransportAdPage /></PrivateRoute>} />
							<Route path="/clone/school/:id" element={<PrivateRoute><CreateRidingSchoolAdPage /></PrivateRoute>} />
							<Route path="/clone/stable/:id" element={<PrivateRoute><CreateStableAdPage /></PrivateRoute>} />
							<Route path="/clone/trainer/:id" element={<PrivateRoute><CreateTrainerAdPage /></PrivateRoute>} />
							<Route path="/clone/event/:id" element={<PrivateRoute><CreateEventAdPage /></PrivateRoute>} />
							<Route path="/clone/vet/:id" element={<PrivateRoute><CreateVetAdPage /></PrivateRoute>} />
							<Route path="/messages" element={<PrivateRoute><MessagesPage /></PrivateRoute>} />
							<Route path="/admin" element={<PrivateRoute><AdminPage /></PrivateRoute>} />
							<Route path="/payment/checkout" element={<PrivateRoute><PaymentCheckoutPage /></PrivateRoute>} />
							<Route path="/payment/success" element={<PrivateRoute><PaymentSuccessPage /></PrivateRoute>} />
							<Route path="/payment/cancel" element={<PrivateRoute><PaymentSuccessPage /></PrivateRoute>} />
							<Route path="/verification" element={<PrivateRoute><SellerVerificationPage /></PrivateRoute>} />
              <Route path="/search" element={<SearchResultsPage />} />
							<Route path="/map-search" element={<MapSearchPage />} />
							<Route path="/privacy" element={<LegalPage slug="privacy" />} />
							<Route path="/terms" element={<LegalPage slug="terms" />} />
							<Route path="/gdpr" element={<LegalPage slug="gdpr" />} />
							<Route path="/forgot-password" element={<ForgotPasswordPage />} />
							<Route path="/reset-password" element={<ResetPasswordPage />} />
            </Routes>
          </main>
          <Footer />
					<ConsentBanner />
          <CookieConsent />
          <Toaster position="top-right" />
        </div>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
